export class TransactionEnvelopeInfo {
    transactionId: string;
    envelopeId: string;
    nop: string;
    userId: string;

    parse(obj: any) {
        if (obj.TransactionId) this.transactionId = obj.TransactionId;
        if (obj.EnvelopeId) this.envelopeId = obj.EnvelopeId;
        if (obj.Nop) this.nop = obj.Nop;
        if (obj.UserId) this.userId = obj.UserId;
    }
}
